import { render, staticRenderFns } from "./Gold.vue?vue&type=template&id=125954b2&scoped=true"
import script from "./Gold.vue?vue&type=script&lang=js"
export * from "./Gold.vue?vue&type=script&lang=js"
import style0 from "./Gold.vue?vue&type=style&index=0&id=125954b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125954b2",
  null
  
)

export default component.exports